/* Straw & Sol — motion v2 (count-up, magnetic, image fade). Reveal lives in ss-reveal.js */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover:hover)').matches;

  /* Image load fade */
  function fadeImgs(root) {
    (root || document).querySelectorAll('img.ss-fade-img:not(.ss-loaded)').forEach(function (img) {
      if (img.complete) { img.classList.add('ss-loaded'); }
      else { img.addEventListener('load', function () { img.classList.add('ss-loaded'); }, { once: true }); }
    });
  }

  /* Count-up stats */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    if (reduce) { el.textContent = prefix + target.toFixed(dec) + suffix; return; }
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + val.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var stats = document.querySelectorAll('.ss-stat__num[data-target]');
    if (!stats.length) return;
    if (!('IntersectionObserver' in window)) { stats.forEach(countUp); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); obs.unobserve(e.target); } });
    }, { threshold: .4 });
    stats.forEach(function (s) { io.observe(s); });
  }

  /* Magnetic buttons (hero/ATC CTA only) */
  function initMagnetic() {
    if (!canHover || reduce) return;
    document.querySelectorAll('.ss-magnetic').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.22;
        var y = (e.clientY - r.top - r.height / 2) * 0.22;
        btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  function boot() { fadeImgs(); initCounters(); initMagnetic(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { fadeImgs(e.target); initCounters(); initMagnetic(); });
})();
